const faq = [
    {
        question: 'How soon will I notice results with Red Maca?',
        answer: 'Most women begin to feel a difference within 1–2 weeks of consistent daily use. You may notice increased energy, improved mood, or better sleep early on. Full hormonal balance benefits may take 3–4 weeks depending on your body.'
    },
    {
        question: 'Does it really help with menopause symptoms?',
        answer: 'Yes. Many of our customers report relief from hot flashes, night sweats, irritability, and low libido during perimenopause and menopause. Red Maca naturally supports hormonal balance without synthetic hormones.'
    },
    {
        question: 'Is it safe to take every day?',
        answer: 'Absolutely. Red Maca is an adaptogen, which means it helps your body adapt to stress and restore balance over time. It’s gentle, non-habit-forming, and safe for long-term daily use when taken as directed.'
    },
    {
        question: 'What’s the difference between the capsules and the powder?',
        answer: 'They both offer the same benefits! Capsules are great if you’re on-the-go or prefer convenience. Powder is perfect if you enjoy smoothies, lattes, or adding superfoods to your recipes. It’s just a matter of lifestyle preference.'
    },
    {
        question: 'Will it interact with my medications or hormone therapy?',
        answer: 'While Red Maca is natural and generally well tolerated, we always recommend consulting with your doctor—especially if you’re on medication or undergoing hormone therapy. Every body is different, and your safety comes first.'
    }
];

export default faq;